import { Form, Badge, Table } from "react-bootstrap";
import Moment from "react-moment";
import VerifiedSignature from "../../../../img/documentsign.png";
import { useEffect } from "react";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FormDataEntrySignature = ({
  getStudySubjectFormReviewDataEntryList,
  dataEntryFormReviewHistory,
  formId,
  StudyMode,
  setToggle6,
  dataEntryFormReviewHistoryLoader,
  emptyDataEntry,
}) => {
  const loginUserId = JSON.parse(localStorage.getItem("uniqueData"));
  const getGMTOffset = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? "+" : "-";
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
    const minutes = String(absMinutes % 60).padStart(2, "0");
    return `GMT${sign}${hours}:${minutes}`;
  };

  useEffect(() => {
    getStudySubjectFormReviewDataEntryList();
  }, [formId]);

  return (
    <>
      {dataEntryFormReviewHistoryLoader ? (
        <PageLoader />
      ) : (
        dataEntryFormReviewHistory?.map((signData, index) => (
          <Form.Group id="footer" className="mb-2 bg-white">
            <div className="bg-light border rounded p-2 mt-4 position-relative">
              <Badge
                className="position-absolute text-muted bg-success-subtle br3"
                style={{ top: -10, left: 20 }}
              >
                {signData?.updatedVersion === "1" ? "SDV on First Entry" : `SDV on Correction ${signData?.updatedVersion - 1}`}
              </Badge>
              <div className="p-2 pt-3">
                <Table
                  bordered
                  className="m-0 border signTable bg-white"
                  style={{ verticalAlign: "middle" }}
                >
                  <tbody>
                    {(signData?.users || [])?.length === 0 ?
                      <div className="p-4 fw-bold text-center" style={{ fontSize: 12 }}>
                        No SDV user has been assigned. Please assign an SDV user to proceed.
                      </div>
                      :
                      (signData?.users || [])?.map((item) => (
                        <tr>
                          {!item?.signatureBy ? (
                            <>
                              <>
                                <td className="text-end" style={{ width: 150 }}>
                                  SDV By:{" "}
                                </td>
                                <td>{`${item?.firstName} ${item?.lastName}`}</td>
                                <td>
                                  <button
                                    disabled={!(StudyMode === "DBP Mode" || StudyMode?.startsWith("SDV")) || item?.isDisable}
                                    className="updateProfile"
                                    onClick={() => setToggle6()}
                                  >
                                    Signature
                                  </button>
                                </td>
                              </>
                            </>
                          ) : (
                            <>
                              {item?.signatureBy && (
                                <>
                                  <td className="text-end" style={{ width: 150 }}>
                                    SDV By:{" "}
                                  </td>
                                  <td>{`${item?.firstName} ${item?.lastName}`}</td>
                                  <td className="p-3">
                                    <div
                                      className="border border-2 rounded-start border-success border-end-0 position-relative"
                                      style={{ maxWidth: "fit-content" }}
                                    >
                                      <div className="p-3">
                                        <div className="hstack gap-2">
                                          <h6 className="m-0 fw-bold">
                                            {item?.firstName}
                                            <br />
                                            {item?.lastName}
                                          </h6>
                                          <div>
                                            <p
                                              className="m-0"
                                              style={{ fontSize: 9 }}
                                            >
                                              Digitally signed by
                                              <br />
                                              {item?.signatureBy}
                                            </p>
                                            <p
                                              className="m-0"
                                              style={{ fontSize: 9 }}
                                            >
                                              Date:{" "}
                                              <Moment format="DD/MM/YYYY" withTitle>
                                                {item?.signatureDT}
                                              </Moment>{" "}
                                              |
                                              <br />
                                              <Moment format="HH:mm:ss" withTitle>
                                                {item?.signatureDT}
                                              </Moment>{" "}
                                              {getGMTOffset() || "NA"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="position-absolute bg-white w-100"
                                        style={{ top: -10, left: 30 }}
                                      >
                                        <p className="fw-bold m-0 ps-1">
                                          eSigned By:
                                        </p>
                                      </div>
                                      <div
                                        className="position-absolute bg-white w-100"
                                        style={{ bottom: -10, left: 30 }}
                                      >
                                        <p className="fw-bold m-0 ps-1">
                                          {item?.signatureCode}
                                        </p>
                                      </div>
                                      <img
                                        className="position-absolute"
                                        style={{
                                          top: 8,
                                          left: 47,
                                          pointerEvents: "none",
                                          filter: "opacity(0.2)",
                                          width: 70,
                                        }}
                                        src={VerifiedSignature}
                                        alt="Signed"
                                      />
                                    </div>
                                  </td>
                                </>
                              )}
                            </>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Form.Group>
        ))
      )}
    </>
  );
};

export default FormDataEntrySignature;
